var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top-bar"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/log-asc-top-bar.svg"),"alt":""}}),_vm._v(" "),(_vm.isAuthenticated)?_c('b-button',{staticClass:"logout cursor-pointer",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.logout}},[_vm._v("Salir")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-637bc5ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = null
// module chunks = 